import { createAction, props } from '@ngrx/store';
import { IConversationData, IMessage } from '../../interfaces/conversations.interfaces';

// Load Conversations
export const loadConversations = createAction('[Chat] Load Conversations');

export const loadConversationsSuccess = createAction(
  '[Chat] Load Conversations Success',
  props<{ conversations: IConversationData[] }>()
);

export const loadConversationsFailure = createAction(
  '[Chat] Load Conversations Failure',
  props<{ error: string }>()
);

// Add Conversation
export const addConversation = createAction(
  '[Chat] Add Conversation',
  props<{ conversation: IConversationData }>()
);

export const addConversationSuccess = createAction(
  '[Chat] Add Conversation Success',
  props<{ conversation: IConversationData }>()
);

export const addConversationFailure = createAction(
  '[Chat] Add Conversation Failure',
  props<{ error: string }>()
);

// Update Conversation
export const updateConversation = createAction(
  '[Chat] Update Conversation',
  props<{ conversationId: string; updates: Partial<IConversationData> }>()
);

export const updateConversationSuccess = createAction(
  '[Chat] Update Conversation Success',
  props<{ conversation: IConversationData }>()
);

export const updateConversationFailure = createAction(
  '[Chat] Update Conversation Failure',
  props<{ error: string }>()
);

// Select Conversation
export const selectConversation = createAction(
  '[Chat] Select Conversation',
  props<{ conversationId: string }>()
);

// Update Last Message
export const updateLastMessage = createAction(
  '[Chat] Update Last Message',
  props<{ conversationId: string; message: string; creatorName?: string }>()
);

// Toggle Typing Indicator
export const toggleTypingIndicator = createAction(
  '[Chat] Toggle Typing Indicator',
  props<{ conversationId: string; isTyping: boolean }>()
);

// Toggle Full Screen
export const toggleChatsFullScreen = createAction(
  '[Chat] Toggle Chats Full Screen',
  props<{ isFullScreen: boolean }>()
);

// Clear Conversations
export const clearConversations = createAction('[Chat] Clear Conversations');

// Set Conversations
export const setConversations = createAction(
  '[Chat] Set Conversations',
  props<{ conversations: IConversationData[] }>()
);

// Update Conversation Offset
export const updateConversationOffset = createAction(
  '[Chat] Update Conversation Offset',
  props<{ conversationId: string; offset: string }>()
);

// Update Message by Timestamp
export const updateMessageByTimestamp = createAction(
  '[Chat] Update Message By Timestamp',
  props<{ conversationId: string; message: IMessage; timestamp: number }>()
);
